// Simple i18n setup for Arabic RTL first with English support

export type Locale = 'ar' | 'en';

export const translations = {
  ar: {
    // Navigation
    home: 'الرئيسية',
    activities: 'الأنشطة',
    categories: 'التصنيفات',
    packages: 'الباقات',
    about: 'عن باليت',
    login: 'تسجيل الدخول',
    signup: 'إنشاء حساب',
    createAccount: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    becomeInstructor: 'كن مدرباً',
    favorites: 'المفضلة',
    browseCategories: 'تصفح التصنيفات',
    
    // Hero
    heroTitle: 'اكسر روتينك مع عائلتك وأصدقائك',
    heroSubtitle: 'أنشطة ممتعة يقدمها مدربون محترفون في بيتك أو ديوانيتك',
    exploreActivities: 'استكشف الأنشطة',
    enterAddress: 'أدخل عنوانك أو منطقتك',
    
    // Categories (updated list)
    allCategories: 'جميع التصنيفات',
    activityCategories: 'تصنيفات الأنشطة',
    artsAndCrafts: 'حرف يدوية',
    cooking: 'طهي',
    fitness: 'لياقة بدنية',
    selfDevelopment: 'تطوير ذاتي',
    gamesAndActivities: 'ألعاب وأنشطة',
    celebrations: 'أعياد واحتفالات',
    animals: 'حيوانات',
    technology: 'تكنولوجيا',
    girlsAndMotherhood: 'فتيات وأمومة',
    bookClubs: 'نادي الكتاب',
    storytelling: 'حكواتي',
    seerahSessions: 'السيرة النبوية',
    valueTalks: 'حوارات قيمة',
    
    // Audience / Group Types
    all: 'الكل',
    family: 'العائلة',
    girls: 'بنات',
    youngWomen: 'شابات',
    men: 'رجال',
    boys: 'أولاد',
    mixed: 'مختلط',
    school: 'مدرسة',
    work: 'عمل',
    
    // Activity Details
    duration: 'المدة',
    minutes: 'دقيقة',
    participants: 'المشاركين',
    person: 'شخص',
    price: 'السعر',
    kwd: 'د.ك',
    materialsIncluded: 'المواد مشمولة',
    materialsNotIncluded: 'المواد غير مشمولة',
    requirements: 'المطلوب',
    requirementsPlaceholder: 'مثال: توفير طاولة كبيرة، تجهيز مكان مضاء، إحضار مريول للأطفال...',
    bookNow: 'احجز الآن',
    reviews: 'التقييمات',
    instructor: 'المدرب',
    groupSize: 'حجم المجموعة',
    activityDescription: 'وصف النشاط',
    similarActivities: 'أنشطة مشابهة',
    addToFavorites: 'أضف للمفضلة',
    removeFromFavorites: 'إزالة من المفضلة',
    
    // Packages
    packagesTitle: 'باقات الاشتراك',
    packagesSubtitle: 'اختر الباقة المناسبة لك واستمتع بأنشطة متنوعة',
    subscribeNow: 'اشترك الآن',
    perMonth: '/شهر',
    monthly: 'شهري',
    yearly: 'سنوي',
    unlimited: 'غير محدود',
    monthlyPlanName: 'الباقة الشهرية',
    monthlyPlanDesc: '4 جلسات شهرياً',
    yearlyPlanName: 'الباقة السنوية',
    yearlyPlanDesc: '4 جلسات شهرياً - فاتورة سنوية',
    yearlyBonus: 'شهر مجاني إضافي!',
    unlimitedPlanName: 'باقة غير محدودة',
    unlimitedPlanDesc: 'جلسات غير محدودة - فاتورة سنوية',
    unlimitedBonus: 'دخول مبكر للأنشطة الجديدة',
    sessionsPerMonth: 'جلسات شهرياً',
    unlimitedSessions: 'جلسات غير محدودة',
    cancelSubscription: 'إلغاء الاشتراك',
    
    // Booking
    selectDate: 'اختر التاريخ',
    selectTime: 'اختر الوقت',
    selectZone: 'اختر المنطقة',
    attendeesCount: 'عدد الحضور',
    notes: 'ملاحظات',
    submitBooking: 'إرسال طلب الحجز',
    
    // Booking Status
    requested: 'قيد الانتظار',
    instructorConfirmed: 'مؤكد من المدرب',
    paid: 'مدفوع',
    completed: 'مكتمل',
    cancelled: 'ملغي',
    confirmed: 'مؤكد',
    pending: 'قيد الانتظار',
    
    // Dashboard
    dashboard: 'لوحة التحكم',
    myBookings: 'حجوزاتي',
    myActivities: 'أنشطتي',
    myProfile: 'حسابي',
    settings: 'الإعدادات',
    users: 'المستخدمين',
    allActivities: 'جميع الأنشطة',
    allBookings: 'جميع الحجوزات',
    analytics: 'الإحصائيات',
    
    // User Account
    savedAddresses: 'العناوين المحفوظة',
    addAddress: 'إضافة عنوان',
    editAddress: 'تعديل العنوان',
    deleteAddress: 'حذف العنوان',
    bookingHistory: 'سجل الحجوزات',
    upcomingBookings: 'الحجوزات القادمة',
    pastBookings: 'الحجوزات السابقة',
    subscriptionDetails: 'تفاصيل الاشتراك',
    currentPlan: 'الباقة الحالية',
    renewalDate: 'تاريخ التجديد',
    upgradePlan: 'ترقية الباقة',
    downgradePlan: 'تخفيض الباقة',
    paymentHistory: 'سجل المدفوعات',
    paymentDate: 'تاريخ الدفع',
    paymentAmount: 'المبلغ',
    paymentStatus: 'الحالة',
    personalDetails: 'البيانات الشخصية',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    noSubscription: 'لا يوجد اشتراك حالي',
    noAddresses: 'لا توجد عناوين محفوظة',
    noPayments: 'لا توجد مدفوعات',
    noBookings: 'لا توجد حجوزات',
    viewDetails: 'عرض التفاصيل',
    downloadInvoice: 'تحميل الفاتورة',
    addressLabel: 'اسم العنوان',
    fullAddress: 'العنوان الكامل',
    activeBookings: 'الحجوزات النشطة',
    completedBookings: 'الحجوزات المكتملة',
    sessionsRemaining: 'الجلسات المتبقية',
    sessionsUsed: 'الجلسات المستخدمة',
    payment: 'دفعة',
    invoice: 'فاتورة',
    
    // Instructor Dashboard
    instructorDashboard: 'لوحة تحكم المدرب',
    totalRevenue: 'إجمالي الإيرادات',
    payoutSummary: 'ملخص المدفوعات',
    pendingPayout: 'مبلغ معلق',
    uploadPhoto: 'رفع صورة',
    editBio: 'تعديل النبذة',
    createActivity: 'إنشاء نشاط جديد',
    editActivity: 'تعديل النشاط',
    activityTitle: 'عنوان النشاط',
    activityTitleAr: 'عنوان النشاط (عربي)',
    activityTitleEn: 'عنوان النشاط (إنجليزي)',
    activityPrice: 'سعر النشاط',
    activityAudience: 'الجمهور المستهدف',
    uploadPhotos: 'رفع الصور',
    saveActivity: 'حفظ النشاط',
    activityDuration: 'مدة النشاط',
    activityCategory: 'تصنيف النشاط',
    activityDescriptionAr: 'وصف النشاط (عربي)',
    activityDescriptionEn: 'وصف النشاط (إنجليزي)',
    minParticipants: 'الحد الأدنى للمشاركين',
    maxParticipants: 'الحد الأقصى للمشاركين',
    includesMaterials: 'هل المواد مشمولة؟',
    yes: 'نعم',
    no: 'لا',
    totalBookings: 'إجمالي الحجوزات',
    acceptBooking: 'قبول الحجز',
    declineBooking: 'رفض الحجز',
    revenue: 'الإيرادات',
    filterByDate: 'تصفية حسب التاريخ',
    thisMonth: 'هذا الشهر',
    lastMonth: 'الشهر الماضي',
    last3Months: 'آخر 3 أشهر',
    allTime: 'كل الوقت',
    expertise: 'الخبرات',
    areasServed: 'المناطق المخدومة',
    availability: 'التوفر',
    bio: 'النبذة الشخصية',
    
    // Auth
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    fullName: 'الاسم الكامل',
    phone: 'رقم الهاتف',
    forgotPassword: 'نسيت كلمة المرور؟',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب؟',
    acceptTermsLabel: 'أوافق على شروط الخدمة وسياسة الخصوصية',
    userSignup: 'إنشاء حساب مستخدم',
    instructorSignup: 'إنشاء حساب مدرب',
    userSignupSubtitle: 'انضم إلى باليت واستمتع بأنشطة ممتعة',
    instructorSignupSubtitle: 'انضم كمدرب وشارك خبراتك',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    mustAcceptTerms: 'يجب الموافقة على الشروط والأحكام',
    signupSuccess: 'تم إنشاء حسابك بنجاح!',
    welcomeBack: 'مرحباً بعودتك!',
    startJourney: 'أنشئ حسابك وابدأ رحلتك',
    
    // Common
    search: 'بحث',
    filter: 'تصفية',
    filterBy: 'تصفية حسب',
    sortBy: 'ترتيب حسب',
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    success: 'تم بنجاح',
    cancel: 'إلغاء',
    save: 'حفظ',
    edit: 'تعديل',
    delete: 'حذف',
    confirm: 'تأكيد',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    viewAll: 'عرض الكل',
    noResults: 'لا توجد نتائج',
    noFavorites: 'لا توجد أنشطة مفضلة',
    noFavoritesDesc: 'أضف أنشطة لمفضلتك لتجدها هنا',
    add: 'إضافة',
    close: 'إغلاق',
    
    // Zones
    capital: 'العاصمة',
    hawally: 'حولي',
    farwaniya: 'الفروانية',
    ahmadi: 'الأحمدي',
    jahra: 'الجهراء',
    mubarakAlKabeer: 'مبارك الكبير',

    // Footer & Contact
    footerTagline: 'اكسر روتينك الأسبوعي مع أنشطة ممتعة',
    contactUs: 'تواصل معنا',
    termsOfService: 'شروط الخدمة',
    privacyPolicy: 'سياسة الخصوصية',
    allRightsReserved: 'جميع الحقوق محفوظة لدى باليت',
    contactEmail: 'البريد الإلكتروني',
    contactPhone: 'الهاتف',
    contactAddress: 'العنوان',
    kuwaitAddress: 'الكويت، دولة الكويت، منطقة العاصمة',
    sendMessage: 'إرسال رسالة',
    yourMessage: 'رسالتك',
    subject: 'الموضوع',
    
    // Legal Pages
    termsTitle: 'شروط الخدمة',
    privacyTitle: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث',
    acceptTerms: 'بالموافقة على هذه الشروط',
    userResponsibilities: 'مسؤوليات المستخدم',
    platformLiability: 'مسؤولية المنصة',
    paymentTerms: 'شروط الدفع',
    cancellationPolicy: 'سياسة الإلغاء',
    dataCollection: 'جمع البيانات',
    dataUsage: 'استخدام البيانات',
    dataSecurity: 'أمان البيانات',
    cookiePolicy: 'سياسة الكوكيز',
    contactForQuestions: 'للأسئلة والاستفسارات',
  },
  en: {
    // Navigation
    home: 'Home',
    activities: 'Activities',
    categories: 'Categories',
    packages: 'Packages',
    about: 'About Palette',
    login: 'Login',
    signup: 'Sign Up',
    createAccount: 'Create Account',
    logout: 'Logout',
    becomeInstructor: 'Become Instructor',
    favorites: 'Favorites',
    browseCategories: 'Browse Categories',
    
    // Hero
    heroTitle: 'Break Your Routine with Family & Friends',
    heroSubtitle: 'Fun activities delivered by professional instructors to your home or diwaniya',
    exploreActivities: 'Explore Activities',
    enterAddress: 'Enter your address or area',
    
    // Categories (updated list)
    allCategories: 'All Categories',
    activityCategories: 'Activity Categories',
    artsAndCrafts: 'Arts & Crafts',
    cooking: 'Cooking',
    fitness: 'Fitness',
    selfDevelopment: 'Self Development',
    gamesAndActivities: 'Games & Activities',
    celebrations: 'Celebrations & Events',
    animals: 'Animals',
    technology: 'Technology',
    girlsAndMotherhood: 'Girls & Motherhood',
    bookClubs: 'Book Clubs',
    storytelling: 'Storytelling',
    seerahSessions: 'Seerah Sessions',
    valueTalks: 'Value Talks',
    
    // Audience / Group Types
    all: 'All',
    family: 'Family',
    girls: 'Girls',
    youngWomen: 'Young Women',
    men: 'Men',
    boys: 'Boys',
    mixed: 'Mixed',
    school: 'School',
    work: 'Work',
    
    // Activity Details
    duration: 'Duration',
    minutes: 'minutes',
    participants: 'Participants',
    person: 'person',
    price: 'Price',
    kwd: 'KWD',
    materialsIncluded: 'Materials Included',
    materialsNotIncluded: 'Materials Not Included',
    requirements: 'Requirements for customer',
    requirementsPlaceholder: 'e.g. Provide a large table, well-lit area, aprons for kids...',
    bookNow: 'Book Now',
    reviews: 'Reviews',
    instructor: 'Instructor',
    groupSize: 'Group Size',
    activityDescription: 'Activity Description',
    similarActivities: 'Similar Activities',
    addToFavorites: 'Add to Favorites',
    removeFromFavorites: 'Remove from Favorites',
    
    // Packages
    packagesTitle: 'Subscription Packages',
    packagesSubtitle: 'Choose the right package for you and enjoy various activities',
    subscribeNow: 'Subscribe Now',
    perMonth: '/month',
    monthly: 'Monthly',
    yearly: 'Yearly',
    unlimited: 'Unlimited',
    monthlyPlanName: 'Monthly Plan',
    monthlyPlanDesc: '4 sessions per month',
    yearlyPlanName: 'Yearly Plan',
    yearlyPlanDesc: '4 sessions per month - billed annually',
    yearlyBonus: 'Extra free month!',
    unlimitedPlanName: 'Unlimited Plan',
    unlimitedPlanDesc: 'Unlimited sessions - billed annually',
    unlimitedBonus: 'Early access to new activities',
    sessionsPerMonth: 'sessions per month',
    unlimitedSessions: 'Unlimited sessions',
    cancelSubscription: 'Cancel Subscription',
    
    // Booking
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    selectZone: 'Select Zone',
    attendeesCount: 'Number of Attendees',
    notes: 'Notes',
    submitBooking: 'Submit Booking Request',
    
    // Booking Status
    requested: 'Requested',
    instructorConfirmed: 'Instructor Confirmed',
    paid: 'Paid',
    completed: 'Completed',
    cancelled: 'Cancelled',
    confirmed: 'Confirmed',
    pending: 'Pending',
    
    // Dashboard
    dashboard: 'Dashboard',
    myBookings: 'My Bookings',
    myActivities: 'My Activities',
    myProfile: 'Profile',
    settings: 'Settings',
    users: 'Users',
    allActivities: 'All Activities',
    allBookings: 'All Bookings',
    analytics: 'Analytics',
    
    // User Account
    savedAddresses: 'Saved Addresses',
    addAddress: 'Add Address',
    editAddress: 'Edit Address',
    deleteAddress: 'Delete Address',
    bookingHistory: 'Booking History',
    upcomingBookings: 'Upcoming Bookings',
    pastBookings: 'Past Bookings',
    subscriptionDetails: 'Subscription Details',
    currentPlan: 'Current Plan',
    renewalDate: 'Renewal Date',
    upgradePlan: 'Upgrade Plan',
    downgradePlan: 'Downgrade Plan',
    paymentHistory: 'Payment History',
    paymentDate: 'Payment Date',
    paymentAmount: 'Amount',
    paymentStatus: 'Status',
    personalDetails: 'Personal Details',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    noSubscription: 'No active subscription',
    noAddresses: 'No saved addresses',
    noPayments: 'No payment history',
    noBookings: 'No bookings',
    viewDetails: 'View Details',
    downloadInvoice: 'Download Invoice',
    addressLabel: 'Address Label',
    fullAddress: 'Full Address',
    activeBookings: 'Active Bookings',
    completedBookings: 'Completed Bookings',
    sessionsRemaining: 'Sessions Remaining',
    sessionsUsed: 'Sessions Used',
    payment: 'Payment',
    invoice: 'Invoice',
    
    // Instructor Dashboard
    instructorDashboard: 'Instructor Dashboard',
    totalRevenue: 'Total Revenue',
    payoutSummary: 'Payout Summary',
    pendingPayout: 'Pending Payout',
    uploadPhoto: 'Upload Photo',
    editBio: 'Edit Bio',
    createActivity: 'Create Activity',
    editActivity: 'Edit Activity',
    activityTitle: 'Activity Title',
    activityTitleAr: 'Activity Title (Arabic)',
    activityTitleEn: 'Activity Title (English)',
    activityPrice: 'Activity Price',
    activityAudience: 'Target Audience',
    uploadPhotos: 'Upload Photos',
    saveActivity: 'Save Activity',
    activityDuration: 'Activity Duration',
    activityCategory: 'Activity Category',
    activityDescriptionAr: 'Activity Description (Arabic)',
    activityDescriptionEn: 'Activity Description (English)',
    minParticipants: 'Minimum Participants',
    maxParticipants: 'Maximum Participants',
    includesMaterials: 'Includes Materials?',
    yes: 'Yes',
    no: 'No',
    totalBookings: 'Total Bookings',
    acceptBooking: 'Accept Booking',
    declineBooking: 'Decline Booking',
    revenue: 'Revenue',
    filterByDate: 'Filter by Date',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    last3Months: 'Last 3 Months',
    allTime: 'All Time',
    expertise: 'Expertise',
    areasServed: 'Areas Served',
    availability: 'Availability',
    bio: 'Bio',
    
    // Auth
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    phone: 'Phone Number',
    forgotPassword: 'Forgot Password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    acceptTermsLabel: 'I accept the Terms of Service and Privacy Policy',
    userSignup: 'Create User Account',
    instructorSignup: 'Create Instructor Account',
    userSignupSubtitle: 'Join Palette and enjoy fun activities',
    instructorSignupSubtitle: 'Join as an instructor and share your expertise',
    passwordMismatch: 'Passwords do not match',
    mustAcceptTerms: 'You must accept the terms and conditions',
    signupSuccess: 'Your account has been created successfully!',
    welcomeBack: 'Welcome back!',
    startJourney: 'Create your account and start your journey',
    
    // Common
    search: 'Search',
    filter: 'Filter',
    filterBy: 'Filter by',
    sortBy: 'Sort By',
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    viewAll: 'View All',
    noResults: 'No results found',
    noFavorites: 'No favorite activities',
    noFavoritesDesc: 'Add activities to your favorites to find them here',
    add: 'Add',
    close: 'Close',
    
    // Zones
    capital: 'Capital',
    hawally: 'Hawally',
    farwaniya: 'Farwaniya',
    ahmadi: 'Ahmadi',
    jahra: 'Jahra',
    mubarakAlKabeer: 'Mubarak Al-Kabeer',

    // Footer & Contact
    footerTagline: 'Break your weekly routine with fun activities',
    contactUs: 'Contact Us',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    allRightsReserved: 'All rights reserved for Palette',
    contactEmail: 'Email',
    contactPhone: 'Phone',
    contactAddress: 'Address',
    kuwaitAddress: 'Kuwait, State of Kuwait, Capital Area',
    sendMessage: 'Send Message',
    yourMessage: 'Your Message',
    subject: 'Subject',
    
    // Legal Pages
    termsTitle: 'Terms of Service',
    privacyTitle: 'Privacy Policy',
    lastUpdated: 'Last Updated',
    acceptTerms: 'By accepting these terms',
    userResponsibilities: 'User Responsibilities',
    platformLiability: 'Platform Liability',
    paymentTerms: 'Payment Terms',
    cancellationPolicy: 'Cancellation Policy',
    dataCollection: 'Data Collection',
    dataUsage: 'Data Usage',
    dataSecurity: 'Data Security',
    cookiePolicy: 'Cookie Policy',
    contactForQuestions: 'For questions and inquiries',
  },
} as const;

export type TranslationKey = keyof typeof translations.ar;

export function t(key: TranslationKey, locale: Locale = 'ar'): string {
  return translations[locale][key] || key;
}

export function getDirection(locale: Locale): 'rtl' | 'ltr' {
  return locale === 'ar' ? 'rtl' : 'ltr';
}
